import type { ViewFieldsFragment } from '@salescore/client-api'
import type { ModalFuncProps } from 'antd'
import { t } from 'i18next'

import { CommitmentKpiLabelForm } from './CommitmentKpiLabelForm'

export const buildCommitmentKpiLabelModalProperties = ({
  onFinish,
  kpiViewId,
  view,
}: {
  onFinish: () => void
  kpiViewId: string
  view: ViewFieldsFragment
}): ModalFuncProps => ({
  icon: null,
  width: '70%',
  cancelText: t(`閉じる`),
  okButtonProps: { style: { display: 'none' } },
  style: { top: '3%' },
  closable: true,
  maskClosable: true,
  destroyOnClose: true,
  content: (
    <div className="w-full">
      <CommitmentKpiLabelForm onFinish={onFinish} kpiViewId={kpiViewId} view={view} />
    </div>
  ),
})
